/* Model */
class DocumentSendingConfigurationModel extends App.Models.BaseModel {
  modelUrl = 'DocumentSendingConfiguration';
}
App.Models.DocumentSendingConfiguration = DocumentSendingConfigurationModel;

/* Collection */
class DocumentSendingConfigurationCollection extends App.Collections.BaseCollection {
  url = 'DocumentSendingConfiguration';
  model = App.Models.DocumentSendingConfiguration;
}
App.Collections.DocumentSendingConfigurations = DocumentSendingConfigurationCollection;

/* Router */
class DocumentSendingConfigurationRouter extends App.Routers.BaseRouter {
  constructor() {
      const entityName = 'DocumentSendingConfiguration';
      const model = App.Models.DocumentSendingConfiguration;
      const collectionClass = App.Collections.DocumentSendingConfigurations;

      super(entityName, model, collectionClass);
  }
}

App.Routers.DocumentSendingConfiguration = DocumentSendingConfigurationRouter;